import { __assign, __rest } from "tslib";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as MuiSkeleton, } from "@mui/material";
export var Skeleton = function (_a) {
    var showIf = _a.showIf, _b = _a.font, font = _b === void 0 ? "inherit" : _b, children = _a.children, _c = _a.variant, variant = _c === void 0 ? "text" : _c, sx = _a.sx, skeletonProps = __rest(_a, ["showIf", "font", "children", "variant", "sx"]);
    // != for check undefined and null
    if (showIf != null && showIf !== false) {
        return _jsx(_Fragment, { children: children || null });
    }
    return (_jsx(MuiSkeleton, __assign({ variant: variant }, skeletonProps, { sx: __assign({ font: font, bgcolor: "currentColor" }, sx) })));
};
